import { successType } from "redux-api-status";
import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function candidateLists(
  state = initialState.candidateLists,
  action
) {
  switch (action.type) {
    case successType(types.LOAD_CANDIDATES):
      const modifiedList = action.payload.map((item) => {
        const historyAndChat = [...item.history, ...item.chat];
        const combinedDate = historyAndChat.map((obj) => {
          const { dateEntered, chatDate } = obj;
          const combined = dateEntered || chatDate;
          return { ...obj, combinedDate: combined };
        });

        combinedDate.sort(
          (a, b) => new Date(b.combinedDate) - new Date(a.combinedDate)
        );

        return { ...item, historyAndChat: combinedDate };
      });

      return { ...state, List: modifiedList };

    case successType(types.LOAD_CANDIDATES_ALL):
      return {
        ...state,
        All: action.payload.data,
      };
    default:
      return state;
  }
}
